import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "amount",
    "adjustedTotal",
    "adjustedTotalYen",
    "adjustedFee",
    "adjustedPayoutPoints",
    "adjustedPayoutYen",
    "minimumAlert",
    "approveButton"
  ]
  static values = {
    total: Number,
    baseAmount: Number,
    feeAmount: Number,
    feeOperator: String,
    minimum: Number
  }

  connect() {
    this.update()
  }

  update() {
    const adjustmentAmount = Number.parseInt(this.amountTarget.value || "0", 10)
    const adjustedBaseAmount = Math.max(this.baseAmountValue - adjustmentAmount, 0)
    const adjustedTotal = this.totalValue - adjustmentAmount
    const adjustedFee = this.calculateFee(adjustedBaseAmount)
    const adjustedPayoutPoints = Math.max(adjustedTotal - adjustedFee, 0)
    const belowMinimum = adjustmentAmount > 0 && adjustedTotal < this.minimumValue

    this.adjustedTotalTarget.textContent = this.formatNumber(Math.max(adjustedTotal, 0))
    this.adjustedTotalYenTarget.textContent = this.formatYen(adjustedTotal)
    this.adjustedFeeTarget.textContent = this.formatNumber(adjustedFee)
    this.adjustedPayoutPointsTarget.textContent = this.formatNumber(adjustedPayoutPoints)
    this.adjustedPayoutYenTarget.textContent = this.formatYen(adjustedPayoutPoints)
    this.minimumAlertTarget.classList.toggle("d-none", !belowMinimum)
    this.approveButtonTarget.disabled = belowMinimum
  }

  calculateFee(baseAmount) {
    if (this.feeOperatorValue === "percentage") {
      return Math.floor(baseAmount * this.feeAmountValue / 100)
    }

    return this.feeAmountValue
  }

  formatNumber(value) {
    return new Intl.NumberFormat("ja-JP").format(value)
  }

  formatYen(points) {
    const yen = Math.max(points, 0) * 0.1
    return new Intl.NumberFormat("ja-JP", {
      maximumFractionDigits: 1
    }).format(yen)
  }
}
